document.addEventListener("DOMContentLoaded", function() {
  function setOverlay(part, color) {
    document.querySelectorAll(`.${part}-overlay`).forEach(img => img.style.display = "none");
    const target = document.getElementById(`${part}-${color}`);
    if(target) target.style.display = "block";
  }

  document.querySelectorAll(".control-group:nth-child(1) .color-buttons button").forEach(btn => {
    btn.addEventListener("click", () => setOverlay("outer", btn.className));
  });

  document.querySelectorAll(".control-group:nth-child(2) .color-buttons button").forEach(btn => {
    btn.addEventListener("click", () => setOverlay("bottom", btn.className));
  });
});
